import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-simule {
  padding: 56px 0;
  background-color: #1a0000;
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.75)), url('assets/partiu-gp-da-inglaterra/simule/bg-simule-mobile.png');
  background-size: cover;
  background-position: center;
}

#partiu-gp-simule .eyebrow {
  margin: 0 0 4px;
  color: #fff;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}

#partiu-gp-simule .titulo {
  margin: 0 0 8px;
  color: #fff;
  font-family: 'SantanderHeadline';
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;
  text-align: center;
}

#partiu-gp-simule .subtitulo {
  margin: 0 0 24px;
  color: #fff;
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
}

#partiu-gp-simule .cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

#partiu-gp-simule .card {
  background: #fff;
  border-radius: 24px;
  padding: 24px;
}

#partiu-gp-simule .card-titulo {
  margin: 0 0 8px;
  color: #222;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
}

#partiu-gp-simule .card-texto {
  margin: 0;
  color: #444;
  font-family: 'SantanderHeadline';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

#partiu-gp-simule .cta {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: fit-content;
  margin: 0 auto 24px;
  padding: 0 32px;
  border-radius: 999px;
  background: #ec0000;
  color: #fff;
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 350ms linear;
}

#partiu-gp-simule .cta:hover {
  background-color: #f14c4c;
}

#partiu-gp-simule .disclaimer {
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'SantanderMicroText';
  font-size: 11px;
  line-height: 16px;
  text-align: center;
}

@media (min-width: 992px) {
  #partiu-gp-simule {
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.75)), url('assets/partiu-gp-da-inglaterra/simule/bg-simule-desktop.png');
  }

  #partiu-gp-simule .titulo {
    margin: 0 0 18px;
    font-size: 60px;
    line-height: 66px;
  }

  #partiu-gp-simule .subtitulo {
    margin: 0 0 44px;
  }

  #partiu-gp-simule .eyebrow {
    font-family: 'SantanderHeadline';
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 16px;
  }

  #partiu-gp-simule .cards {
    flex-direction: row;
  }

  #partiu-gp-simule .card {
    flex: 1;
  }

  #partiu-gp-simule .card-titulo {
    margin-bottom: 16px;
    font-size: 24px;
    line-height: 32px;
  }

  #partiu-gp-simule .card-texto {
    font-size: 24px;
    line-height: 32px;
  }

  #partiu-gp-simule .disclaimer {
    text-align: left;
    font-size: 14px;
    line-height: 21px;
  }
}
`;

export default styles;